import { $admin } from "@/services/api";
import apiEndpoints from "@/constants/api-endpoints";

/**
 * Create a new seed
 * @param {Object} payload Request payload containing seed details
 * @returns {Promise}
 */
export const createSeed = (payload) => {
  return $admin.post(apiEndpoints.seeds, payload);
};

/**
 * Update seed details
 * @param {Object} payload Request payload containing seed details to be updated
 * @returns {Promise}
 */
export const updateSeed = ({ id, ...payload }) => {
  return $admin.put(`${apiEndpoints.seeds}/${id}`, payload);
};

/**
 * Deletes seed
 * @param {Object} id Id of the seed to be deleted
 * @returns {Promise}
 */
export const deleteSeed = (id) => {
  return $admin.delete(`${apiEndpoints.seeds}/${id}`);
};

/**
 * Authorise seed address
 * @returns {Promise}
 */
export const authorizeSeed = (payload) => {
  return $admin.post(`${apiEndpoints.seeds}/authorize_url`, payload);
};

/**
 * Save seed address access token
 * @param {Object} payload Request payload sample {"seed_address": "test@inbox.net", "code": ""}
 * @returns {Promise}
 */
export const seedAccessToken = (payload) => {
  return $admin.post(`${apiEndpoints.seeds}/access_token`, payload);
};

/**
 * Fetches latest 5 error loags of a seed address
 * @param {String} seed_address Seed address {Email}
 * @returns {Promise} List of errors and their reason
 */
export const errorLogs = (seed_address) => {
  return $admin.get(
    `${apiEndpoints.seeds}/errors?seed_address=${seed_address}`
  );
};
